import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=5e1b5fdc&"
import script from "./gallery.vue?vue&type=script&lang=ts&"
export * from "./gallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports